import { ReactElement } from 'react';

import { RadioGroupItem } from '@dreryk/react-components';
import { BindingCreator } from '@dreryk/react-common';

import { translationKeys } from '../../../translations';
import { RESERVATION_PREFERENCES } from '../../../shared/reservationPreference';

import { ReservationPreference } from './ReservationPreferenceField.types';
import { StyledReservationPreferenceField } from './ReservationPreferenceField.styled';

const ITEMS: RadioGroupItem<ReservationPreference>[] = RESERVATION_PREFERENCES.map((preference) => ({
   id: preference,
   label: translationKeys.reservationPreferenceFormFieldDescription[preference],
}));

type ReservationPreferenceFormBeanPart = {
   reservationPreference: ReservationPreference;
};

type ReservationPreferenceFieldProps = {
   register: BindingCreator<ReservationPreferenceFormBeanPart>;
};

export const ReservationPreferenceField = (props: ReservationPreferenceFieldProps): ReactElement => {
   return (
      <StyledReservationPreferenceField<ReservationPreference>
         testId={'reservationPreference'}
         items={ITEMS}
         controller={props.register('reservationPreference')}
         defaultValue={'PRACTITIONER'}
         label={translationKeys.whatIsTheMostImportantForPatient}
      />
   );
};
